<template>
  <div class="delete-file-container">
    <el-form :model="findForm" :rules="rules" ref="findForm" label-width="100px" class="find-form" :inline="true">
      <el-form-item label="文件来源" prop="origin">
        <el-select v-model="findForm.origin" placeholder="请选择文件来源">
          <el-option label="openApi" value="openApi"></el-option>
          <el-option label="XPS系统" value="xpsSystem"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="搜索规则" prop="rule">
        <el-select v-model="findForm.rule" placeholder="请选择搜索规则" @change="handleChange">
          <el-option label="CDN地址" value="cdn"></el-option>
          <el-option label="文件名称" value="name"></el-option>
          <el-option label="上传时间" value="date"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上传人员" prop="user">
        <el-select v-model="findForm.userId" placeholder="请选择上传人员" clearable filterable remote :remote-method="getUserList" :loading="loading">
          <el-option v-for="item in userInfo" :key="item.userId" :label="item.fullName" :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="删除人员" prop="user">
        <el-select v-model="findForm.deleteUserId" placeholder="请选择删除人员" clearable filterable remote :remote-method="getUserList" :loading="loading">
          <el-option v-for="item in userInfo" :key="item.userId" :label="item.fullName" :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="findForm.rule==='cdn'" label="CDN地址" prop="cdn">
        <el-input v-model="findForm.cdn" class="form-input" placeholder="请输入CDN地址" @keydown.enter.native="getDeleteFileLogs('findForm')"></el-input>
      </el-form-item>
      <el-form-item v-if="findForm.rule==='name'" label="文件名称" prop="name">
        <el-input v-model="findForm.name" class="form-input" placeholder="请输入文件名称" @keydown.enter.native="getDeleteFileLogs('findForm')"></el-input>
      </el-form-item>
      <el-form-item v-if="findForm.rule==='date'" label="上传时间" prop="uploadTime">
        <el-date-picker class="form-input" v-model="findForm.uploadTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="删除时间" prop="deleteTime">
        <el-date-picker class="form-input" v-model="findForm.deleteTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
        </el-date-picker>
      </el-form-item>
      <el-form-item align="center">
        <el-button type="primary" @click="getDeleteFileLogs('findForm')">搜索</el-button>
        <el-button @click="resetForm('findForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="find-file-container">
      <el-table :data="tableData" style="width: 100%" :max-height="450" :highlight-current-row="true">
        <div slot="empty" class="empty-content empty-image">
          <p class="empty-text">删除的文件在此处搜索哦~</p>
        </div>
        <el-table-column label="文件名称" prop="fileName" show-overflow-tooltip min-width="180px">
          <template v-slot="{row}">
            <div class="file-content file-page-container">
              <img class="file-image" src="https://front-xps-cdn.xsyx.xyz/custom/xps/images/delete.png" fit="contain" title="文件已删除" />
              <span class="file-name">{{row.fileName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="上传人员" prop="realName" align="center" min-width="120px">
        </el-table-column>
        <el-table-column label="删除人员" prop="operator" align="center" min-width="120px">
        </el-table-column>
        <el-table-column label="CDN地址" prop="url" show-overflow-tooltip min-width="400px">
          <template v-slot="{row}">
            <span class="table-cdn" v-clipboard:copy="row.url" v-clipboard:success="onCopy">{{row.url}}</span>
          </template>
        </el-table-column>
        <el-table-column label="上传时间" prop="uploadTime" width="150px">
          <template v-slot="{row}">
            {{row.uploadTime?formatTime(row.uploadTime):''}}
          </template>
        </el-table-column>
        <el-table-column label="删除时间" prop="createTime" width="150px">
          <template v-slot="{row}">
            {{row.createTime?formatTime(row.createTime):''}}
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" min-width="150px">
          <template slot="header" slot-scope="scope">
            <el-input v-model="search" size="mini" placeholder="输入关键字搜索" />
          </template>
          <template v-slot="{row}">
            <el-button type="text" @click="showDeleteDetail(row)">查看删除日志</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="find-container-pager" @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="pageConfig.pageNum" :page-sizes="[10, 50, 100, 200]" :page-size="pageConfig.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" :pager-count="5">
      </el-pagination>

      <el-dialog :title="dialog.title" :visible.sync="dialog.visible" :before-close="destroyComponent" :modal="false">
        <component :is="dialog.component" @close="destroyComponent" :log="logInfo" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getExt, isImg } from '@/common/utils/ext.js';
import { deleteApi, userApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import dayjs from 'dayjs';
import { dialogMixin } from "@/common/mixins/";
import deleteLogDetail from './deleteLogDetail.vue';
export default {
  name: 'delete-file',
  mixins: [dialogMixin],
  data () {
    return {
      findForm: {
        origin: 'xpsSystem',
        rule: 'name',
        cdn: '',
        name: '',
        userId: '',
        deleteUserId: '',
        uploadTime: [new Date(+new Date() - 7 * 24 * 60 * 60 * 1000), new Date()],
        deleteTime: [new Date(+new Date() - 7 * 24 * 60 * 60 * 1000), new Date()]
      },
      pageConfig: {
        pageNum: 1,
        pageSize: 10
      },
      rules: {
        origin: [
          { required: true, message: '请选择文件来源', trigger: 'change' }
        ],
        rule: [
          { required: true, message: '请选择上传规则', trigger: 'change' }
        ],
        cdn: [
          { required: true, message: '请输入CDN地址', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入文件名称', trigger: 'blur' }
        ],
        uploadTime: [
          { required: true, message: '请选择上传时间', trigger: 'change' }
        ],
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      findFileList: [],
      search: '',
      total: 0,
      loading: false,
      userInfo: [],
      logInfo: {}
    };
  },
  computed: {
    tableData () {
      return this.findFileList.filter(data => !this.search || data.fileName.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  methods: {
    // 查询删除日志详情
    async getDeleteLogDetail (id) {
      showLoading();
      const res = await deleteApi.getDeleteLogDetail({ id })
      if (res.code === 200) {
        res.data.ext = getExt(res.data.url);
        res.data.isImg = isImg(res.data.url);
        this.logInfo = res.data;
        this.setDialog(true, '文件删除日志详情', deleteLogDetail);
      } else {
        this.$message.error(res.message);
      }
      hideLoading();
    },
    // 查询删除日志列表
    getDeleteFileLogs (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          showLoading();
          const res = await deleteApi.getDeleteFileLogs({ ...this.findForm, ...this.pageConfig });
          if (res.code === 200) {
            if (res.data.length > 0) {
              res.data.forEach(item => {
                item.isImg = isImg(item.url);
                item.ext = getExt(item.url);
              })
            }
            this.findFileList = res.data;
            this.total = res.total;
          } else {
            this.$message.error(res.message);
          }
          hideLoading();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    // 弹窗组件销毁
    destroyComponent () {
      this.setDialog(false, "", null, "1100px", "1vh");
    },
    // 显示删除日志详情
    showDeleteDetail (row) {
      this.getDeleteLogDetail(row.id);

    },
    // 复制
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 当当前页数改变，触发事件
    handlePageChange (num) {
      this.pageConfig.pageNum = num;
      this.getDeleteFileLogs('findForm');
    },
    // 当页面显示数据总数改变，触发事件
    handleSizeChange (size) {
      this.pageConfig.pageSize = size;
      this.getDeleteFileLogs('findForm');
    },
    // 获取用户列表
    getUserList (realName) {
      this.loading = true;
      setTimeout(async () => {
        this.loading = false
        const res = await userApi.getUserList({ realName })
        this.userInfo = res.userInfo
      }, 200);
    },
    // 搜索规则下拉框change事件
    handleChange (val) {
      this.$refs["findForm"].resetFields(); // 重置表单校验
      this.findForm.rule = val; // 再次赋值
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-file-container {
  .form-input {
    width: 400px;
  }
  .find-file-container {
    position: relative;
    height: 500px;
    .empty-content.empty-image {
      height: 400px;
      background-size: 60%;
      background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/file-destroy.png");
    }
    .empty-text.other-text {
      position: relative;
      top: 40px;
    }
    .find-container-pager {
      margin-top: 10px;
      text-align: center;
    }
  }
  .file-content {
    display: flex;
    justify-content: left;
    align-items: center;
    .file-image {
      display: inline-block;
      margin-right: 20px;
      width: 40px;
      max-height: 40px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      &.file-icon {
        height: 40px;
      }
    }
  }
  .table-cdn {
    cursor: pointer;
    &:hover {
      color: #409eff;
    }
  }
}
</style>